export default {
      id: "oc-res-vpc-network-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-vpc-network",
      toString: function () {
        return this.url;
      }
    }